<div class="fill-height d-flex justify-content-center">
  <div class="d-flex w-100 flex-grow-1 position-relative">
    <div class="d-flex flex-column position-absolute w-100 h-100 overflow-auto">

      <!-- ========================== SCROLL AREA ========================== -->
      <div class="d-flex flex-column px-lg-big-q-and-a">

        <h4 class="zx-page-title py-0 px-1 m-0 d-flex pb-2 pb-md-4 pt-md-3">
          <b>
            {{ "main-nav.q-and-a" | translate }}
          </b>
        </h4>

        <!-- ========================== Qs AREA ========================== -->
        <div class="w-100 flex-grow-1 d-flex">
          <mat-accordion class="w-100" [class.zx-rtl]="isRTL">
            <ng-container *ngFor="let q of questionOrder">
            <!-- --------- Q1 --------- איך מדפיסים באיזיקס? -->
            <mat-expansion-panel *ngIf="q===1" [expanded]="expandedQuestionIndex === 1" (expandedChange)="onPanelExpandedChange($event, 1)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a">
                <p>
                  {{ "q-and-a.1.content-1" | translate }}
                </p>
                <p class="fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "q-and-a.1.content-2" | translate }}
                </p>
                <p>
                  {{ "q-and-a.1.content-3" | translate }}
                </p>
                <p class="fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "q-and-a.1.content-4" | translate }}
                </p>
                <!-- plotter -->
                <div class="d-flex row">
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex col-12 col-md-6 align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/plotter-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.plotter" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-plotter-1" | translate }}
                    </p>
                    <span class="spacer d-none d-lg-flex"></span>
                    <button type="button" mat-stroked-button color="primary"
                      class="zx-small-tiny-btn rounded-pill mx-2 d-none d-lg-flex" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // plotter -->
                  <!-- express -->
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex col-12 col-md-6 align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/express-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.express" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-express-1" | translate }}
                    </p>
                    <span class="spacer d-none d-lg-flex"></span>
                    <button type="button" mat-stroked-button color="primary"
                      class="zx-small-tiny-btn rounded-pill mx-2 d-none d-lg-flex" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // express -->
                  <!-- pics -->
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/pics-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.pics" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-pics-1" | translate }}
                    </p>
                    <span class="spacer"></span>
                    <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill mx-2"
                      [class.text-white]="isDarkMode" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // pics -->
                </div>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q1 --------- איך מדפיסים באיזיקס? -->

            <!-- --------- Q2 --------- מהי הדפסת פלוטר? -->
            <mat-expansion-panel *ngIf="q===2" [expanded]="expandedQuestionIndex === 2" (expandedChange)="onPanelExpandedChange($event, 2)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  <div class="d-flex align-items-center gap-2">
                    <img class="zx-small-icon-size" [src]="'assets/images/plotter-icon.svg'">
                    <span>
                      {{ "my-orders.what-is-plotter" | translate }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.1.content-plotter-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.btn-try" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q2 --------- מהי הדפסת פלוטר?  -->

            <!-- --------- Q3 --------- מהי הדפסת מסמכים? -->
            <mat-expansion-panel *ngIf="q===3" [expanded]="expandedQuestionIndex === 3" (expandedChange)="onPanelExpandedChange($event, 3)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  <div class="d-flex align-items-center gap-2">
                    <img class="zx-small-icon-size" [src]="'assets/images/express-icon.svg'">
                    <span>
                      {{ "my-orders.what-is-express" | translate }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.1.content-express-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.btn-try" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q3 --------- מהי הדפסת מסמכים? -->

            <!-- --------- Q4 --------- מהי הדפסת תמונות? -->
            <mat-expansion-panel *ngIf="q===4" [expanded]="expandedQuestionIndex === 4" (expandedChange)="onPanelExpandedChange($event, 4)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  <div class="d-flex align-items-center gap-2">
                    <img class="zx-small-icon-size" [src]="'assets/images/pics-icon.svg'">
                    <span>
                      {{ "my-orders.what-is-pics" | translate }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.1.content-pics-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.btn-try" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q3 --------- מהי הדפסת תמונות? -->

            <!-- --------- Q5 --------- איך לערוך קובץ להדפסה? -->
            <mat-expansion-panel *ngIf="q===5" [expanded]="expandedQuestionIndex === 5" (expandedChange)="onPanelExpandedChange($event, 5)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.2.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.2.content-1" | translate }}
                </p>
                <p class="q-and-a-edit-print-shimmer fw-bold mb-2">
                  {{ "q-and-a.2.content-2" | translate:{count: editGuideSoftwareKeys.length} }}
                </p>
                <div class="d-flex flex-wrap gap-2 justify-content-center w-100 mb-2">
                  <span *ngFor="let key of editGuideSoftwareKeys"
                        class="rounded-pill px-3 py-1 zx-text-small d-inline-block c-pointer"
                        [class.bg-white]="!isDarkMode"
                        [class.bg-dark]="isDarkMode"
                        [class.text-dark]="!isDarkMode"
                        [class.text-white]="isDarkMode"
                        style="border: 1px solid rgba(0,0,0,0.12);"
                        (click)="goToEditInstructions()">
                    <span class="q-and-a-edit-print-shimmer">{{ key | translate }}</span>
                  </span>
                </div>
                <p>
                  {{ "q-and-a.2.content-3" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToEditInstructions()" [class.text-white]="isDarkMode">
                  <span class="q-and-a-edit-print-shimmer">{{ "q-and-a.2.btn-edit-guide" | translate }}</span>
                </button>
                <p *ngIf="lang && lang !== 'he'" class="text-green fw-bold pt-3">
                  {{ "processing-file.only-he" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q4 --------- איך לערוך קובץ להדפסה? -->

            <!-- --------- Q6 --------- מהן שעות הפעילות של הסניפים? -->
            <mat-expansion-panel *ngIf="q===6" [expanded]="expandedQuestionIndex === 6" (expandedChange)="onPanelExpandedChange($event, 6)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.3.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a">
                <p>
                  {{ "q-and-a.3.content-1" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q5 --------- מהן שעות הפעילות של הסניפים? -->

            <!-- --------- Q7 --------- הוראות הגעה לסניפים -->
            <mat-expansion-panel *ngIf="q===7" [expanded]="expandedQuestionIndex === 7" (expandedChange)="onPanelExpandedChange($event, 7)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.4.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.4.content-1" | translate }}
                </p>
                <div *ngIf="!clustersLoadCompleted" class="w-100 d-flex justify-content-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                </div>
                <div *ngIf="clustersLoadCompleted && clusters.length > 0" class="row g-3 py-2 justify-content-center">
                  <div *ngFor="let cluster of clusters" class="col-12 col-sm-6 col-lg-4">
                    <button
                      type="button"
                      mat-button
                      class="q-and-a-cluster-btn rounded-pill w-100 text-center d-flex justify-content-center align-items-center gap-2"
                      [class.q-and-a-cluster-btn-selected]="selectedArrivalClusterSerialName === cluster.serial_name"
                      (click)="onSelectArrivalCluster(cluster)">
                      <img
                        *ngIf="cluster.serial_name"
                        [src]="'assets/images/branches/' + cluster.serial_name + '.png'"
                        [alt]="getClusterDisplayName(cluster.serial_name)"
                        class="q-and-a-cluster-icon"
                        onerror="this.style.display='none'">
                      <span [class.text-white]="isDarkMode">{{ getClusterDisplayName(cluster.serial_name) || cluster.serial_name }}</span>
                    </button>
                    <div *ngIf="selectedArrivalClusterSerialName === cluster.serial_name" class="mt-2">
                      <div *ngFor="let printer of getPrintersInCluster(cluster)"
                        class="q-and-a-printer-arrival mb-3 p-3 rounded d-flex align-items-start gap-2" [class.q-and-a-printer-arrival-dark]="isDarkMode">
                        <div class="q-and-a-printer-arrival-icons flex-shrink-0">
                          <img [src]="getPrintTypeIcon(printer.printType)"
                            [alt]="'choose-branch.printer.' + printer.printType | translate"
                            class="q-and-a-printer-arrival-type-icon">
                        </div>
                        <div class="flex-grow-1 min-w-0">
                          <div class="fw-bold mb-2" [class.text-white]="isDarkMode">{{ printer.displayName }}</div>
                          <div *ngIf="getShortAddress(printer.addressKey, printer.serialName)" class="mb-1 q-and-a-arrival-address" [class.text-white]="isDarkMode">
                            {{ getShortAddress(printer.addressKey, printer.serialName) }}
                          </div>
                          <div *ngIf="getArrivalInstructions(printer.addressKey, printer.serialName)" class="q-and-a-arrival-address" [class.text-white]="isDarkMode">
                            {{ getArrivalInstructions(printer.addressKey, printer.serialName) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p *ngIf="clustersLoadCompleted && clusters.length === 0" class="opacity-75 mb-0" [class.text-white]="isDarkMode">
                  {{ "su-management.monitor.no-data" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q6 --------- הוראות הגעה לסניפים -->

            <!-- --------- Q8 --------- איזה סוגי נייר יש, ואיפה? -->
            <mat-expansion-panel *ngIf="q===8" [expanded]="expandedQuestionIndex === 8" (expandedChange)="onPanelExpandedChange($event, 8)">
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.5.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.5.content-1" | translate }}
                </p>
                <div *ngIf="!clustersLoadCompleted" class="w-100 d-flex justify-content-center py-4">
                  <mat-spinner diameter="40"></mat-spinner>
                </div>
                <div *ngIf="clustersLoadCompleted && clusters.length > 0" class="row g-3 py-2 justify-content-center">
                  <div *ngFor="let cluster of clusters" class="col-12 col-sm-6 col-lg-4">
                    <button
                      type="button"
                      mat-button
                      class="q-and-a-cluster-btn rounded-pill w-100 text-center d-flex justify-content-center align-items-center gap-2"
                      [class.q-and-a-cluster-btn-selected]="selectedPaperTypesClusterSerialName === cluster.serial_name"
                      (click)="onSelectPaperTypesCluster(cluster)">
                      <img
                        *ngIf="cluster.serial_name"
                        [src]="'assets/images/branches/' + cluster.serial_name + '.png'"
                        [alt]="getClusterDisplayName(cluster.serial_name)"
                        class="q-and-a-cluster-icon"
                        onerror="this.style.display='none'">
                      <span [class.text-white]="isDarkMode">{{ getClusterDisplayName(cluster.serial_name) || cluster.serial_name }}</span>
                    </button>
                    <div *ngIf="selectedPaperTypesClusterSerialName === cluster.serial_name" class="mt-2" (click)="$event.stopPropagation()">
                      <div *ngFor="let printer of selectedPaperTypesClusterPrinters"
                        class="q-and-a-printer-arrival mb-3 p-3 rounded d-flex flex-column gap-2" [class.q-and-a-printer-arrival-dark]="isDarkMode">
                        <div class="d-flex align-items-start gap-2">
                          <img [src]="getPrintTypeIcon(printer.printType)"
                            [alt]="'choose-branch.printer.' + printer.printType | translate"
                            class="q-and-a-printer-arrival-type-icon">
                          <div class="fw-bold" [class.text-white]="isDarkMode">{{ printer.displayName }}</div>
                        </div>
                        <div *ngFor="let paper of printer.paperTypes" class="ms-4 mt-2">
                          <div class="d-flex align-items-center gap-2 flex-wrap">
                            <span class="fw-bold" [class.text-white]="isDarkMode">
                              {{ "paper-type.name." + getPaperTypeNameKey(paper) | translate }}
                            </span>
                            <span
                              *ngIf="getPaperDescriptionKey(paper)"
                              class="q-and-a-paper-i-explain-btn d-inline-flex align-items-center"
                              [attr.data-tooltip]="(isPaperExplainExpanded(printer.serialName, getPaperTypeNameKey(paper)) ? 'edit-instructions.step-12-antialias-collapse' : 'collect.click-more-info') | translate"
                              [attr.aria-label]="(isPaperExplainExpanded(printer.serialName, getPaperTypeNameKey(paper)) ? 'edit-instructions.step-12-antialias-collapse' : 'collect.click-more-info') | translate"
                              (pointerdown)="onPaperExplainClick(printer, paper); $event.stopPropagation(); $event.preventDefault()"
                              (click)="$event.stopPropagation()">
                              <img src="assets/images/i-explain-icon.svg" class="q-and-a-paper-i-explain" alt="">
                            </span>
                          </div>
                          <div *ngIf="printer.printType === 'plotter' && getPaperWidthText(paper, printer.printType)" class="mt-1 q-and-a-arrival-address" [class.text-white]="isDarkMode">
                            {{ getPaperWidthText(paper, printer.printType) }}
                          </div>
                          <div *ngIf="(printer.printType === 'express' || printer.printType === 'pics') && getPaperDimensionsText(paper, printer.printType)" class="mt-1 q-and-a-arrival-address" [class.text-white]="isDarkMode">
                            {{ getPaperDimensionsText(paper, printer.printType) }}
                          </div>
                          <div *ngIf="isPaperExplainExpanded(printer.serialName, getPaperTypeNameKey(paper)) && getPaperDescriptionKey(paper)" class="mt-2 q-and-a-arrival-address opacity-90" [class.text-white]="isDarkMode">
                            {{ getPaperDescriptionKey(paper) | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p *ngIf="clustersLoadCompleted && clusters.length === 0" class="opacity-75 mb-0" [class.text-white]="isDarkMode">
                  {{ "su-management.monitor.no-data" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q8 --------- איזה סוגי נייר יש, ואיפה? -->
            </ng-container>

          </mat-accordion>
        </div>
        <!-- // ========================== Qs AREA ========================== -->

      </div>
      <!-- // ========================== SCROLL AREA ========================== -->

    </div>
  </div>

</div>

<!-- תמיד: 2 כפתורים זה לצד זה – "צור הזמנה חדשה" + ווצאפ (כמו בעמוד /edit) -->
<div class="p-2 d-flex flex-column">
  <div class="pt-2 pt-md-2 d-flex align-items-center gap-2 px-lg-big-q-and-a q-and-a-bottom-btns">
    <button class="q-and-a-new-order-btn rounded-pill fw-bold" [class.text-green]="!isDarkMode"
      [class.text-white]="isDarkMode" mat-flat-button type="button" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
    <button type="button" class="q-and-a-whatsapp-btn rounded-pill d-flex align-items-center justify-content-center gap-2 flex-row-reverse"
      (click)="openWhatsAppDefault()" aria-label="WhatsApp">
      <span class="q-and-a-whatsapp-text d-none d-md-inline">{{ "helpers.contact-support-whatsapp" | translate }}</span>
      <span class="q-and-a-whatsapp-logo-wrap">
        <img src="assets/images/whatsup-logo.svg" alt="WhatsApp" class="q-and-a-whatsapp-icon">
      </span>
    </button>
  </div>
</div>